import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.source.upload');
import { Input, Output, EventEmitter, ViewChild, ElementRef, HostListener, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-source-upload',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.source.upload/view.scss */
:host {
  display: block;
  color: var(--ui-text);
  font-size: 13px;
  line-height: 1.5;
}

button, input, select, textarea {
  font-family: inherit;
}

::selection {
  background: var(--ui-selected);
  color: var(--ui-ink);
}

:is(button, a, input, select, textarea, summary):focus-visible {
  outline: 2px solid var(--ui-accent);
  outline-offset: 3px;
}

.drop-overlay {
  position: fixed;
  inset: 16px 16px 16px calc(var(--workspace-sidebar-width, 200px) + 16px);
  z-index: 30;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  border: 2px dashed var(--ui-accent);
  border-radius: var(--ui-radius);
  background: rgba(245, 246, 250, 0.9490196078);
  color: var(--ui-accent);
  pointer-events: none;
}

.drop-overlay > i {
  font-size: 36px;
}

.drop-overlay strong {
  font-size: 18px;
  font-weight: 600;
}

.drop-overlay span {
  font-size: 13px;
}

.upload-panel {
  margin-bottom: 10px;
  border: 0;
  border-radius: var(--ui-radius);
  background: var(--ui-selected);
  overflow: hidden;
}

.upload-summary {
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 6px 12px;
}

.upload-toggle {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 0;
  min-height: 36px;
  text-align: left;
  font-size: 13px;
  color: var(--ui-muted);
}

.upload-toggle strong {
  color: var(--ui-accent);
  font-weight: 650;
  font-size: 13px;
}

.upload-actions {
  display: flex;
  gap: 6px;
  align-items: center;
}

.upload-actions .button {
  padding: 6px 10px;
  font-size: 13px;
  min-height: 36px;
}

.upload-meter {
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 0 12px 10px;
}

.upload-meter progress {
  flex: 1;
  min-width: 0;
  height: 5px;
  appearance: none;
  border: 0;
  border-radius: 3px;
  overflow: hidden;
  background: var(--ui-selected);
}

.upload-meter progress::-webkit-progress-bar, .upload-transfer progress::-webkit-progress-bar {
  background: var(--ui-selected);
}

.upload-meter progress::-webkit-progress-value, .upload-transfer progress::-webkit-progress-value {
  background: var(--ui-accent);
}

.upload-meter progress::-moz-progress-bar, .upload-transfer progress::-moz-progress-bar {
  background: var(--ui-accent);
}

.upload-meter span {
  font-size: 12px;
  color: var(--ui-muted);
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.upload-rows {
  max-height: 230px;
  overflow: auto;
  background: var(--ui-paper);
  border-top: 1px solid var(--ui-line);
}

.upload-row {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 44px;
  padding: 7px 12px;
  font-size: 13px;
}

.upload-row > div {
  min-width: 0;
  flex: 1;
}

.upload-row strong {
  display: block;
  font-size: 13px;
  font-weight: 550;
  color: var(--ui-ink);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.upload-row small {
  display: block;
  margin-top: 2px;
  font-size: 12px;
  color: var(--ui-muted);
  overflow-wrap: anywhere;
}

.upload-row > span {
  font-size: 12px;
  white-space: nowrap;
  color: var(--ui-muted);
}

.upload-row > span.failed {
  color: var(--ui-danger);
}

.upload-row > span.sending {
  color: var(--ui-accent);
}

.upload-destination {
  padding: 7px 12px;
  font-size: 12px;
  color: var(--ui-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.upload-message, .upload-error {
  font-size: 13px;
  line-height: 1.7;
  margin: 8px 12px;
  color: var(--ui-muted);
}

.upload-error {
  color: var(--ui-danger);
  overflow-wrap: anywhere;
}

/* Header, file queue and footer form one compact transfer window. */
.upload-dialog {
  width: calc(100% - 32px);
  max-width: 640px;
  height: fit-content;
  max-height: calc(100dvh - 32px);
  padding: 0;
  border: 0;
  border-radius: var(--ui-radius);
  color: var(--ui-text);
  background: var(--ui-paper);
  overflow: hidden;
  box-shadow: var(--ui-overlay-shadow);
}

.upload-dialog[open] {
  display: flex;
  flex-direction: column;
}

.upload-dialog::backdrop {
  background: rgba(24, 30, 40, 0.4);
}

.upload-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  padding: 18px 20px 14px;
  flex-shrink: 0;
}

.upload-heading > div {
  min-width: 0;
}

.upload-heading h2 {
  color: var(--ui-ink);
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.025em;
  margin: 0;
  line-height: 1.4;
}

.upload-heading .icon-button {
  width: 36px;
  height: 36px;
}

.upload-target {
  display: flex;
  gap: 7px;
  align-items: center;
  font-size: 12px;
  color: var(--ui-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 5px 0 0;
}

.upload-target i {
  flex-shrink: 0;
}

.upload-body {
  flex: 0 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 8px 20px 20px;
  overflow: auto;
  scroll-padding-block: 12px;
}

.upload-selection {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  border: 0;
  border-radius: var(--ui-radius);
  overflow: hidden;
  transition: background 0.15s;
}

.upload-selection:has(.upload-item) {
  flex: none;
  border: 1px solid var(--ui-line);
}

.is-dragging .upload-selection {
  border-color: var(--ui-accent);
  background: var(--ui-selected);
}

.is-dragging .upload-dropzone {
  border-color: var(--ui-accent);
  background: var(--ui-selected);
}

.upload-dropzone {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 190px;
  gap: 9px;
  padding: 24px 16px;
  background: var(--ui-soft);
  border: 1px dashed var(--ui-control);
  border-radius: var(--ui-radius);
}

.upload-empty-icon {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  color: var(--ui-accent);
  font-size: 24px;
}

.upload-dropzone strong {
  color: var(--ui-ink);
  font-size: 16px;
  font-weight: 650;
  letter-spacing: -0.015em;
}

.upload-dropzone p {
  font-size: 13px;
  line-height: 1.6;
  color: var(--ui-muted);
  margin: 0;
}

.upload-dropzone > div {
  display: flex;
  gap: 8px;
  margin-top: 3px;
}

.upload-dropzone .button, .upload-footer .button {
  min-height: 36px;
  padding: 7px 14px;
  font-size: 13px;
  border-radius: 8px;
}

.upload-dropzone small {
  font-size: 12px;
  color: var(--ui-muted);
}

.upload-list-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 6px 12px;
  background: var(--ui-soft);
  border-bottom: 1px solid var(--ui-line);
  flex-shrink: 0;
}

.upload-plan {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  font-size: 12px;
  color: var(--ui-muted);
}

.upload-plan strong {
  font-size: 13px;
  color: var(--ui-ink);
  font-weight: 650;
}

.upload-plan .upload-excluded {
  color: var(--ui-warning);
}

.upload-add {
  display: flex;
  gap: 12px;
  white-space: nowrap;
}

.upload-add button {
  font-size: 12px;
  color: var(--ui-accent);
  min-height: 32px;
}

.upload-add i {
  font-size: 12px;
  margin-right: 3px;
}

.upload-preview {
  flex: auto;
  min-height: 0;
  max-height: min(320px, 45dvh);
  overflow: auto;
  scrollbar-gutter: stable;
}

.upload-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 7px 12px;
  border-bottom: 0;
  min-height: 44px;
}

.upload-item:has(.upload-file-name small) {
  min-height: 52px;
}

.upload-item:last-child {
  border-bottom: 0;
}

.upload-file-icon {
  display: grid;
  place-items: center;
  width: 26px;
  height: 30px;
  flex-shrink: 0;
  color: var(--ui-accent);
  font-size: 17px;
}

.upload-file-name {
  flex: 1;
  min-width: 0;
}

.upload-file-name strong {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 550;
  color: var(--ui-ink);
  line-height: 1.5;
}

.upload-file-name small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  color: var(--ui-muted);
  margin-top: 2px;
  line-height: 1.45;
}

.upload-file-name small.file-error {
  color: var(--ui-warning);
}

.upload-file-state {
  flex-shrink: 0;
  font-size: 12px;
  color: var(--ui-muted);
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.upload-file-state.sending {
  color: var(--ui-accent);
}

.upload-file-state.failed {
  color: var(--ui-danger);
}

.upload-remove {
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  font-size: 17px;
  color: var(--ui-muted);
}

.upload-remove:hover {
  background: var(--ui-soft);
  color: var(--ui-text);
}

.upload-item.excluded .upload-file-icon {
  color: var(--ui-warning);
}

.upload-folder-item {
  display: flex;
  gap: 10px;
  align-items: center;
  min-height: 44px;
  padding: 8px 12px;
  font-size: 13px;
  color: var(--ui-muted);
}

.upload-folder-item span {
  min-width: 0;
  overflow-wrap: anywhere;
}

.upload-list-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 4px 12px;
  border-top: 1px solid var(--ui-line);
  font-size: 12px;
  color: var(--ui-muted);
  flex-shrink: 0;
}

.upload-list-footer button {
  font-size: 12px;
  color: var(--ui-muted);
  min-height: 32px;
}

.upload-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 20px;
  border-top: 1px solid var(--ui-line);
  background: var(--ui-paper);
  flex-shrink: 0;
  min-height: 56px;
}

.upload-footer > span {
  min-width: 0;
  font-size: 12px;
  line-height: 1.6;
  color: var(--ui-muted);
}

.upload-footer-actions {
  display: flex;
  gap: 8px;
  margin-left: auto;
  flex-shrink: 0;
}

.upload-footer .button {
  white-space: nowrap;
}

.upload-dialog > .upload-error {
  margin: 8px 18px;
  font-size: 13px;
  max-height: 60px;
  overflow: auto;
  flex-shrink: 0;
}

.upload-dialog :is(button, input) {
  scroll-margin-block: 12px;
}

.upload-transfer {
  padding: 10px 12px;
  border-bottom: 1px solid var(--ui-line);
  flex-shrink: 0;
}

.upload-transfer > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-size: 12px;
  color: var(--ui-muted);
}

.upload-transfer strong {
  font-size: 13px;
  font-weight: 650;
  color: var(--ui-accent);
}

.upload-transfer progress {
  display: block;
  width: 100%;
  height: 5px;
  appearance: none;
  border: 0;
  border-radius: 3px;
  overflow: hidden;
  margin: 10px 0 6px;
  background: var(--ui-selected);
}

.upload-transfer small {
  display: block;
  text-align: right;
  font-size: 12px;
  color: var(--ui-muted);
  font-variant-numeric: tabular-nums;
}

@media (max-width: 960px) {
  .drop-overlay {
    inset: calc(var(--workspace-header-height, 92px) + 12px) 12px 12px;
  }
}
@media (max-width: 620px) {
  .upload-summary {
    flex-wrap: wrap;
  }
  .upload-toggle {
    flex-basis: 100%;
    min-height: 44px;
  }
  .upload-actions {
    margin-left: auto;
  }
  .upload-meter {
    flex-wrap: wrap;
    gap: 8px;
  }
  .upload-meter progress {
    flex-basis: 100%;
  }
  .upload-dialog {
    max-height: calc(100dvh - 24px);
    width: calc(100% - 24px);
  }
  .upload-heading {
    padding: 14px 16px 12px;
  }
  .upload-heading .icon-button {
    width: 44px;
    height: 44px;
  }
  .upload-body {
    padding: 12px 16px;
  }
  .upload-footer {
    padding: 10px 16px;
    flex-wrap: wrap;
    gap: 8px;
  }
  .upload-footer > span {
    flex-basis: 100%;
  }
  .upload-dropzone {
    min-height: 200px;
    padding: 18px 12px;
  }
  .upload-dropzone strong, .upload-dropzone p {
    text-align: center;
  }
  .upload-list-toolbar {
    flex-wrap: wrap;
    padding: 6px 10px;
  }
  .upload-add {
    margin-left: auto;
  }
  .upload-item {
    min-height: 52px;
    padding: 6px 10px;
    gap: 8px;
  }
  .upload-file-icon {
    width: 24px;
    font-size: 15px;
  }
  .upload-remove {
    min-width: 44px;
    width: 44px;
    height: 44px;
  }
  .upload-preview {
    max-height: 36dvh;
  }
  .upload-dialog > .upload-error {
    margin: 8px 16px;
  }
  .upload-footer .button, .upload-dropzone .button, .upload-actions .button, .upload-add button, .upload-list-footer button {
    min-height: 44px;
  }
}
@media (pointer: coarse) {
  .upload-toggle, .upload-footer .button, .upload-dropzone .button, .upload-actions .button, .upload-add button, .upload-list-footer button {
    min-height: 44px;
  }
  .upload-heading .icon-button, .upload-remove {
    min-width: 44px;
    width: 44px;
    height: 44px;
  }
}
@media (max-height: 600px) {
  .upload-dialog {
    max-height: calc(100dvh - 20px);
  }
  .upload-heading {
    padding-block: 10px;
  }
  .upload-body {
    padding-block: 10px;
  }
  .upload-footer {
    padding-block: 8px;
    min-height: 52px;
  }
  .upload-dropzone {
    min-height: 160px;
    padding-block: 14px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .upload-selection, .upload-transfer progress::-webkit-progress-value {
    transition: none;
  }
}
/* The dialog owns its entrance; files and progress never perform a second entrance. */
@media (prefers-reduced-motion: no-preference) {
  .drop-overlay {
    animation: upload-drop-arrive var(--motion-ui, 180ms) ease-out;
  }
  .upload-dropzone {
    transition: background-color var(--motion-fast, 120ms), border-color var(--motion-fast, 120ms);
  }
  .upload-file-state, .upload-row > span {
    transition: color var(--motion-fast, 120ms);
  }
  .upload-remove {
    transition: background-color var(--motion-fast, 120ms), color var(--motion-fast, 120ms);
  }
}
@keyframes upload-drop-arrive {
  from {
    opacity: 0.85;
  }
  to {
    opacity: 1;
  }
}
/* Upload limits, destination and transfer state remain comfortably readable. */
.upload-target, .upload-dropzone small, .upload-footer > span, .upload-footer p,
.upload-row small, .upload-row > span, .upload-destination, .upload-meter span, .upload-plan {
  font-size: 13px;
}

/* Transfer window: a quiet source tray with live progress and attached controls. */
.upload-dialog {
  border-radius: 16px;
  box-shadow: var(--ui-overlay-shadow, 0 18px 64px rgba(23, 59, 50, 0.16));
}

.upload-dialog::backdrop {
  background: rgba(23, 59, 50, 0.32);
  backdrop-filter: blur(3px);
}

.upload-heading {
  padding: 17px 20px 14px;
  background: var(--ui-soft);
  border-bottom: 1px solid var(--ui-line);
}

.upload-heading h2 {
  font-size: 18px;
  font-weight: 650;
}

.upload-heading .icon-button {
  border-radius: 9px;
  background: var(--ui-paper);
  color: var(--ui-muted);
}

.upload-heading .icon-button:hover:not(:disabled) {
  background: var(--ui-selected);
  color: var(--ui-accent);
}

.upload-body {
  padding: 18px 20px;
}

.upload-dropzone {
  min-height: 210px;
  background: var(--ui-soft);
  border: 1px dashed var(--ui-control);
  border-radius: 12px;
  gap: 10px;
}

.upload-empty-icon {
  width: 48px;
  height: 48px;
  border-radius: 0;
  background: transparent;
  color: var(--ui-accent);
  font-size: 30px;
  box-shadow: none;
}

.upload-dropzone strong {
  font-size: 17px;
  font-weight: 600;
}

.upload-selection:has(.upload-item) {
  border: 0;
  border-radius: 10px;
  background: var(--ui-paper);
}

.upload-list-toolbar {
  padding: 8px 12px;
  background: var(--ui-soft);
  border: 0;
}

.upload-plan strong {
  font-size: 14px;
}

.upload-preview {
  border-bottom: 1px solid var(--ui-line);
}

.upload-item {
  min-height: 54px;
  padding: 9px 12px;
}

.upload-item + .upload-item {
  border-top: 1px solid var(--ui-line);
}

.upload-file-icon {
  width: 30px;
  height: 34px;
  border-radius: 7px;
  background: var(--ui-soft);
}

.upload-remove {
  border-radius: 8px;
}

.upload-file-name small.file-error {
  white-space: normal;
  overflow: visible;
  overflow-wrap: anywhere;
}

.upload-list-footer {
  border: 0;
  background: var(--ui-soft);
  padding: 6px 12px;
}

.upload-transfer {
  padding: 12px;
  background: var(--ui-selected);
  border: 0;
}

.upload-footer {
  background: var(--ui-soft);
  padding: 12px 20px;
}

.upload-panel {
  background: var(--ui-paper);
  border: 1px solid var(--ui-line);
  border-radius: 12px;
  box-shadow: none;
}

.upload-summary {
  background: var(--ui-selected);
  padding: 8px 12px;
}

.upload-toggle strong {
  color: var(--ui-ink);
  font-weight: 600;
}

.upload-meter {
  padding-top: 10px;
}

.upload-row + .upload-row {
  border-top: 1px solid var(--ui-line);
}

.upload-row strong {
  font-size: 14px;
}

.drop-overlay {
  background: rgba(221, 230, 221, 0.96);
  backdrop-filter: blur(3px);
  border-radius: 16px;
}

@media (max-width: 620px) {
  .upload-heading {
    padding: 14px;
  }
  .upload-body {
    padding: 14px;
  }
  .upload-footer {
    padding: 12px 14px;
  }
  .upload-dropzone {
    min-height: 210px;
    padding: 20px 12px;
  }
  .upload-dropzone strong {
    font-size: 16px;
  }
  .upload-item {
    padding: 8px 10px;
    gap: 8px;
  }
  .upload-file-icon {
    width: 26px;
    height: 30px;
  }
}
@media (max-height: 600px) {
  .upload-heading {
    padding-block: 10px;
  }
  .upload-body {
    padding-block: 10px;
  }
  .upload-dropzone {
    min-height: 160px;
    padding-block: 14px;
    gap: 7px;
  }
  .upload-footer {
    padding-block: 8px;
  }
}`],
})
export class ComponentSourceUploadComponent implements OnDestroy {
    @Input() parent=''; @Input() csrf=''; @Input() canWrite=false;
    @Output() completed=new EventEmitter<void>();
    @ViewChild('uploadDialog') dialog!:ElementRef<HTMLDialogElement>;
    modalOpen=false; closing=false;
    rows:any[]=[]; folders:string[]=[]; target=''; error=''; dragging=false; scanning=false;
    running=false; paused=false; started=false; expanded=true; foldersReady=false;
    private xhr:XMLHttpRequest|null=null; private dead=false;
    constructor(@Inject(Service) public service:Service) {}
    ngOnDestroy() { this.dead=true; this.xhr?.abort(); }
    summaryLabel() {
        if(this.scanning) return '파일 확인 중';
        if(this.running) return this.paused ? '중단 중' : '업로드 중';
        if(this.paused) return '업로드 중단됨';
        if(this.count('FAILED')) return this.count('WAIT') ? '일부 실패 · 남은 파일 대기' : '일부 파일 등록 실패';
        return this.pending() ? '업로드 대기' : '업로드 완료';
    }
    pending() { return this.scanning || this.running || this.rows.some(r=>['WAIT','FAILED'].includes(r.state)) || (!this.foldersReady && this.folders.length>0); }
    canLeave() {
        if(this.running || this.scanning) { this.error='업로드를 중단한 뒤 화면을 이동해 주세요.'; this.service.render(); return false; }
        return !this.pending() || window.confirm('남은 업로드 목록을 지우고 이동할까요?');
    }
    @HostListener('window:beforeunload',['$event'])
    beforeUnload(event:BeforeUnloadEvent) { if(this.pending()) { event.preventDefault(); event.returnValue=''; } }
    @HostListener('window:dragover',['$event'])
    preventFileOpen(event:DragEvent) { if(event.dataTransfer?.types.includes('Files')) event.preventDefault(); }
    @HostListener('window:drop',['$event'])
    preventFileDrop(event:DragEvent) { if(event.dataTransfer?.types.includes('Files')) event.preventDefault(); this.dragging=false; }
    drag(event:DragEvent) {
        if(!event.dataTransfer?.types.includes('Files')) return;
        event.preventDefault();
        event.dataTransfer.dropEffect=this.canWrite && this.parent && !this.running?'copy':'none';
        const active=!!(this.canWrite && this.parent && !this.started && !this.running);
        if(this.dragging!==active) { this.dragging=active;this.service.render(); }
    }
    leave(event:DragEvent) {
        if(this.dragging && !(event.currentTarget as HTMLElement).contains(event.relatedTarget as Node)) { this.dragging=false; this.service.render(); }
    }
    async open() {
        if(!this.canWrite || !this.parent) return;
        if(this.closing) return;
        if(this.started && !this.pending()) this.reset();
        if(!this.rows.length && !this.folders.length) {
        this.target=this.parent;
        }
        this.modalOpen=true;this.dragging=false;
        await this.service.render();
        if(!this.dialog.nativeElement.open) {
            this.dialog.nativeElement.showModal();
        }
    }
    reset() { this.rows=[];this.folders=[];this.error='';this.started=false;this.paused=false;this.foldersReady=false; }
    clear() { if(this.running || this.scanning) return; if(this.pending() && !window.confirm('남은 업로드 목록을 지울까요?')) return; this.reset();this.service.render(); }
    async close(event?:Event) {
        event?.preventDefault();if(this.scanning || this.closing) return;
        this.closing=true;this.dragging=false;
        if(this.dead) return;
        this.dialog.nativeElement.close();this.modalOpen=false;this.closing=false;this.expanded=false;
        await this.service.render();
    }
    remove(row:any) { if(this.started || this.scanning) return;this.rows=this.rows.filter(item=>item!==row);this.service.render(); }
    clearSelection() { if(this.started || this.scanning) return;this.rows=[];this.folders=[];this.error='';this.service.render(); }
    filename(row:any) { return row.path.split('/').pop(); }
    folder(row:any) { const pos=row.path.lastIndexOf('/');return pos<0?'':row.path.slice(0,pos); }
    icon(row:any) { return /\.pdf$/i.test(row.path)?'fa-regular fa-file-pdf':'fa-regular fa-file-lines'; }
    async pick(event:Event) {
        const input=event.target as HTMLInputElement;
        const files=Array.from(input.files || []); input.value='';
        this.add(files.map(file=>({file,path:file.webkitRelativePath || file.name})),[]);
    }
    async drop(event:DragEvent) {
        if(!event.dataTransfer?.types.includes('Files')) return;
        event.preventDefault();event.stopPropagation();this.dragging=false;
        if(!this.canWrite || this.running || this.scanning) return;
        if(!this.parent) { this.error='업로드할 보관 폴더를 먼저 선택해 주세요.';await this.service.render();return; }
        // Entries must be captured before leaving the drop event's protected data store.
        const items=Array.from(event.dataTransfer?.items || []).filter(item=>item.kind==='file');
        const roots=items.map(item=>({entry:(item as any).webkitGetAsEntry?.(),file:item.getAsFile()}));
        if(this.started && this.pending()) { this.error='남은 업로드를 마치거나 목록을 비운 뒤 추가해 주세요.'; await this.service.render(); return; }
        if(this.pending() && this.target && this.target!==this.parent) { this.error='기존 업로드 목록을 마치거나 비운 뒤 다른 폴더에 추가해 주세요.';await this.service.render();return; }
        await this.open();this.scanning=true;this.error='';await this.service.render();
        const files:any[]=[];const folders:string[]=[];let nodes=0;
        const walk=async(entry:any,prefix='')=>{
            if(++nodes>4000) throw new Error('한 번에 파일·폴더 4,000개까지 선택해 주세요.');
            const path=prefix+entry.name;
            if(path.split('/').length>32) throw new Error('폴더 깊이는 32단계까지 지원합니다.');
            if(entry.isFile) {
                const file=await new Promise<File>((resolve,reject)=>entry.file(resolve,reject));
                files.push({file,path});
            } else if(entry.isDirectory) {
                folders.push(path);
                const reader=entry.createReader();
                while(true) {
                    const children:any[]=await new Promise((resolve,reject)=>reader.readEntries(resolve,reject));
                    if(!children.length) break;
                    for(const child of children) await walk(child,path+'/');
                }
            }
        };
        try {
            for(const root of roots) {
                if(root.entry) await walk(root.entry);
                else if(root.file) files.push({file:root.file,path:root.file.name});
                else throw new Error('폴더를 읽지 못했습니다. 폴더 선택 버튼을 이용해 주세요.');
            }
            this.add(files,folders);
        } catch(e) { this.error=e.message || '파일·폴더를 읽지 못했습니다.'; }
        finally { this.scanning=false;await this.service.render(); }
    }
    validPath(path:string) {
        return path.length<=500 && path.split('/').length<=32 && path.split('/').every(part=>
            part && part===part.trim() && !part.startsWith('.') && !/[\\\\:*?"<>|\x00-\x1f]/.test(part) && new TextEncoder().encode(part).length<=255);
    }
    add(files:any[],folders:string[]) {
        if(this.running || this.started) return;
        if(files.length+this.rows.length>2000 || folders.length+this.folders.length>2000) { this.error='파일과 폴더는 각각 2,000개까지 선택해 주세요.';this.service.render();return; }
        const known=new Set(this.rows.map(r=>r.path));const directories=new Set(this.folders);
        for(const path of folders) {
            const normalized=path.normalize('NFC');
            if(!this.validPath(normalized)) { this.error='폴더 이름이나 경로를 확인해 주세요: '+path;this.service.render();return; }
            directories.add(normalized);
        }
        for(const item of files) {
            const path=item.path.normalize('NFC');if(known.has(path)) continue;known.add(path);
            let reason='';
            if(!this.validPath(path)) reason='지원하지 않는 이름·경로';
            else if(!/\.(pdf|hwp|hwpx|txt|md|csv|tsv|json|jsonl|xml|zip|doc|docx|xls|xlsx|ppt|pptx|png|jpg|jpeg|py)$/i.test(path)) reason='지원하지 않는 형식';
            else if(item.file.size>250*1024*1024) reason='250 MB 초과';
            else if(!item.file.size) reason='빈 파일';
            if(!reason) {
                const parts=path.split('/');parts.pop();
                for(let n=1;n<=parts.length;n++) directories.add(parts.slice(0,n).join('/'));
            }
            this.rows.push({file:item.file,path,bytes:0,state:reason?'SKIP':'WAIT',message:reason});
        }
        this.folders=Array.from(directories).sort();this.service.render();
    }
    key(index:number,row:any) { return row.path; }
    count(state:string) { return this.rows.filter(r=>r.state===state).length; }
    totalBytes() { return this.rows.filter(r=>r.state!=='SKIP').reduce((n,r)=>n+r.file.size,0); }
    sentBytes() { return this.rows.reduce((n,r)=>n+r.bytes,0); }
    percent() { return this.totalBytes()?Math.min(100,Math.floor(this.sentBytes()/this.totalBytes()*100)):0; }
    destination() { return this.target.split('/').map((part,index)=>index===0?({storage:'보관함'}[part] || part):part).join(' / '); }
    size(n:number) { return n<1024?n+' B':n<1048576?(n/1024).toFixed(1)+' KB':n<1073741824?(n/1048576).toFixed(1)+' MB':(n/1073741824).toFixed(2)+' GB'; }
    label(row:any) { return {WAIT:'대기',SENDING:Math.floor(row.bytes/row.file.size*100)+'% 전송',SAVING:'서버에 등록 중',DONE:'완료',FAILED:'실패',SKIP:'제외'}[row.state]; }
    request(action:string,form:FormData,row?:any):Promise<any> {
        return new Promise((resolve,reject)=>{
            const xhr=new XMLHttpRequest();this.xhr=xhr;
            xhr.open('POST','/wiz/api/page.sources/'+action);xhr.timeout=600000;
            if(row) {
                xhr.upload.onprogress=event=>{if(event.lengthComputable && !this.dead) {row.bytes=Math.min(row.file.size,Math.round(event.loaded/event.total*row.file.size));this.service.render();}};
                xhr.upload.onload=()=>{if(!this.dead) {row.bytes=row.file.size;row.state='SAVING';this.service.render();}};
            }
            xhr.onload=()=>{try { resolve(JSON.parse(xhr.responseText)); } catch { reject(new Error(xhr.status===413?'파일은 250 MB까지 올릴 수 있습니다.':'등록 결과를 확인하지 못했습니다. 다시 시도해 주세요.')); }};
            xhr.onerror=xhr.ontimeout=()=>reject(new Error('연결을 확인한 뒤 다시 시도해 주세요. 완료된 파일은 다시 저장하지 않습니다.'));
            xhr.onabort=()=>reject(new Error('업로드가 중단되었습니다.'));
            xhr.send(form);
        });
    }
    async run(retry=false) {
        if(this.running || this.scanning) return;
        if(retry) this.rows.filter(r=>r.state==='FAILED').forEach(r=>{r.state='WAIT';r.bytes=0;r.message='';});
        this.running=true;this.started=true;this.paused=false;this.error='';
        await this.service.render();
        if(this.modalOpen) (this.dialog.nativeElement.querySelector('.upload-footer button') as HTMLElement)?.focus({preventScroll:true});
        try {
            if(!this.foldersReady) {
                const form=new FormData();form.append('path',this.target);form.append('csrf',this.csrf);form.append('folders',JSON.stringify(this.folders));
                const res=await this.request('upload_folders',form);
                if(res.code!==200) throw new Error(res.data?.message || '폴더를 만들지 못했습니다.');
                this.foldersReady=true;
            }
            for(const row of this.rows) {
                if(this.paused || this.dead) break;
                if(row.state!=='WAIT') continue;
                row.state='SENDING';row.message='';await this.service.render();
                const form=new FormData();
                const values={path:this.target,relative:row.path,csrf:this.csrf};
                for(const key of Object.keys(values)) form.append(key,values[key]);
                form.append('file',row.file,row.path.split('/').pop());
                try {
                    const res=await this.request('upload_tree',form,row);
                    if([401,403].includes(res.code)) this.paused=true;
                    if(res.code!==200) throw new Error(res.data?.message || '파일을 등록하지 못했습니다.');
                    row.state='DONE';row.bytes=row.file.size;row.message=res.data.already?'이미 보관된 파일':'';
                } catch(e) {row.state='FAILED';row.bytes=0;row.message=e.message;}
                if(!this.dead) await this.service.render();
            }
        } catch(e) {this.error=e.message;this.paused=true;}
        finally {
            this.running=false;this.xhr=null;
            if(!this.dead) {this.completed.emit();await this.service.render();}
        }
    }
    pause() { this.paused=true;this.service.render(); }
}

export default ComponentSourceUploadComponent;